import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import pick from 'lodash.pick';
import { isMoment } from 'moment'; // This class facilitates the conversion of plain JS objects to class objects
// Classes that wish to support this conversion should extend this class
// They must implement shareableFields and fromPlainObject

var Shareable = /*#__PURE__*/function () {
  function Shareable() {
    _classCallCheck(this, Shareable);
  }

  _createClass(Shareable, [{
    key: "isNull",
    // Determines whether or not this object should be converted to null during toPlainObject()
    value: function isNull() {
      return false;
    } // Returns a new copy of this object

  }, {
    key: "clone",
    value: function clone() {
      return this.constructor.fromPlainObject(this.toPlainObject());
    } // Converts a Shareable object into a plain JS object
    // When a shareableField is also Shareable, it will be converted into a plain JS object too
    // Moment objects will be converted into UNIX timestamps (seconds, not milliseconds)

  }, {
    key: "toPlainObject",
    value: function toPlainObject() {
      if (this.isNull()) {
        return null;
      }

      var fields = this.constructor.shareableFields();
      var data = pick(this, fields); // Handle moment objects

      var momentFields = fields.filter(function (field) {
        return isMoment(data[field]);
      });
      momentFields.forEach(function (field) {
        return data[field] = data[field].unix();
      }); // Nested toJSON on other Shareable fields

      var recursiveFields = fields.filter(function (field) {
        return data[field] instanceof Shareable;
      });
      recursiveFields.forEach(function (field) {
        return data[field] = data[field].toPlainObject();
      }); // Nested toJSON on Shareable[] fields

      var arrayRecursiveFields = fields.filter(function (field) {
        return Array.isArray(data[field]);
      }).filter(function (field) {
        return field.length > 0;
      }).filter(function (field) {
        return data[field][0] instanceof Shareable;
      });
      arrayRecursiveFields.forEach(function (field) {
        return data[field] = data[field].map(function (element) {
          return element.toPlainObject();
        });
      });
      return data;
    } // Converts this object to an object of another class

  }, {
    key: "to",
    value: function to(klass) {
      return klass.fromPlainObject(this.toPlainObject());
    } // Converts the data in this object to a plain object of another class

  }, {
    key: "toPlainObjectOf",
    value: function toPlainObjectOf(klass) {
      return this.to(klass).toPlainObject();
    }
  }], [{
    key: "fromPlainObject",
    // Constructs a Shareable object from a plain JS object
    // TODO: possibly some common code for construction or catching common errors like constructing from a Shareable
    // TODO: support creating from Shareable objects instead of requiring fully plain objects
    value: function fromPlainObject(obj) {
      throw new Error('No construction from a plain object defined');
    } // Define which fields should be 'exported' when converting back to a plain JS object

  }, {
    key: "shareableFields",
    value: function shareableFields() {
      throw new Error('No shareable fields defined');
    }
  }]);

  return Shareable;
}();

export { Shareable as default };